export const sanitizeText = (text: string): string => {
  return Array.from(text)
    .filter((char) => {
      const code = char.charCodeAt(0);
      return code > 31 && code !== 127;
    })
    .join('')
    .trim();
};

export const isValidUrl = (url: string): boolean => {
  try {
    const urlObj = new URL(url);
    return ['http:', 'https:'].includes(urlObj.protocol);
  } catch {
    return false;
  }
};

export const sanitizeUrl = (url: string): string | null => {
  if (!url || !isValidUrl(url)) {
    return null;
  }
  return url;
};
